export default __webpack_public_path__ + "static/technologie-44b3e6232be819c7a7b0f7f0d41929a9.jpg";